// extracted by mini-css-extract-plugin
module.exports = {"Order":"Order__Order__4yi4Z"};